// extracted by mini-css-extract-plugin
export default {"cls1":"PaginationMenu-Button_cls1__Yj83M","cls2":"PaginationMenu-Button_cls2__F7nJV PaginationMenu-Button_cls1__Yj83M"};